
export default{
        appName:"富騰匯",
 home:"首頁",
 about:"關於",
 products:"產品",
 service:"服務",
 btn_trade:"開始投資",
 btn_cs:"預約諮詢",
 btn_contact:"聯絡我們",
 btn_more:"了解更多",
 theme:{
 title:"專業金融投資顧問<br><span>助您財富加值</span>",
 desc:"提供優質的CFD交易策略和全面的投資組合建議，讓您的資金<br>增值更加安全高效。"
 },
 model1:{
 title:"專業投資顧問服務",
 desc:"我們提供全面的金融投資服務，幫助您實現財富增值和資產保值。",
 li01:{
 title:"CFD交易策略",
 desc:"提供差價合約(CFD)交易的專業建議與策略，協助您在各類市場中把握交易機會。"
 },
 li02:{
 title:"投資組合管理",
 desc:"提供差價合約(CFD)交易的專業建議與策略，協助您在各類市場中把握交易機會。"
 },
 li03:{
 title:"財務規劃",
 desc:"提供差價合約(CFD)交易的專業建議與策略，協助您在各類市場中把握交易機會。"
 },
 },
 model2:{
 title:"我們的產品",
 desc:"我們的產品",
 more:"查看更多服務",
 li01:{
 title:"外匯/期貨",
 desc:"多樣化外匯與期貨市場分享，量身打造智慧策略與交易訊號"
 },
 li02:{
 title:"股票",
 desc:"深入研究全球股票走勢，提供獨家數據模型與策略建議"
 },
 li03:{
 title:"指數",
 desc:"聚焦主要市場指數表現，智慧推送趨勢訊號與風險提示"
 },
 li04:{
 title:"貴金屬",
 desc:"專注黃金、白銀等貴金屬市場，為您客製化量化策略與即時分析"
 }
 },
 model3:{
 title:"我們的承諾",
 desc:"無論您是經驗豐富的交易者還是新手小白，我們都會為您提供自信交易所需要的工具",
 li01:{
 title:"由交易者打造，為交易者服務",
 desc:"透過深入研究、利用數據科學方法和運用獨特的行業洞察力，我們打造了一個操作簡便的平台，同時助力交易持續提升交易技能。"
 },
 li02:{
 title:"永不止步",
 desc:"我們之所以能夠提供流暢無阻的用戶體驗，源於我們堅持精益求精，為斷優化平台，並專注於提供技術驅動的創新工具，助力交易者更自信地交易，做出更明智的決策。"
 },
 li03:{
 title:"始終保持透明",
 desc:"我們致力於打破交易壁壘，提供業界最透明的收費標準，並提供清晰易懂、內容豐富的交易策略。"
 },
 li04:{
 title:"不斷提升專業能力",
 desc:"我們的全球團隊擁有十年的交易技術經驗和深厚的專業知識，為便捷易用、技術驅動且清晰直觀的平台提供有力支持。"
 }
 },
 guide_home:{
 li01:{
 title:"13",
 desc:"年行業經驗"
 },
 li02:{
 title:"50+",
 desc:"專業顧問團隊"
 },
 li03:{
 title:"1萬+",
 desc:"服務客戶數量"
 },
 li04:{
 title:"20億+",
 desc:"管理資產規模"
 }
 },
        //About
 aboutModel:{
 title:"關於富騰匯",
 desc:"富騰匯顧問致力於為客戶提供專業、全面的金融投資顧問服務，攜手客戶共創財富未來。",
 model1:{
 label:"企業文化",
 title:"我們的使命、願景與價值觀",
 desc:"這些核心理念指引著我們的日常營運和長期發展，是我們為客戶創造價值的基礎。",
 li01:{
 title:"我們的使命",
 desc:"透過專業的金融投資顧問服務，幫助客戶實現財富增值和資產保值，為客戶的財務未來保駕.護航。我們致力於為每一-位客戶提供量身定制的投資解決方案，助力他們實現財務目標和夢想。"
 },
 li02:{
 title:"我們的願景",
 desc:"成為中國最受信賴的金融投資顧問服務提供商，引領行業標準和服務創新。我們希望透過我們的專業服務，提升客戶的投資體驗和成果，同時促進金融市場的健康發展和普惠金融的推廣。"
 },
 li03:{
 title:"我們的價值觀",
 desc:"專業:持續學習和專業成長，為客戶提供最專業的服務。誠信:堅持誠實守信，透明運營，贏得客戶的長期信任。創新:擁抱變化,不斷創新，引領行業發展。共贏:與客戶、員工和合作夥伴共同成長,實現多方共贏。"
 },
 },
 model2:{
 label:"發展歷程",
 title:"我們的成長足跡",
 desc:"從創立之初到如今的行業領導者，每一步都見證了我們的堅持與創新。",
 li01:{
 title:"2015年",
 desc:"富騰匯在香港成立，初期專注於為高淨值人士提供個人理財和投資諮詢服務。"
 },
 li02:{
 title:"2017年",
 desc:"業務擴展至CFD交易領域，與國際知名交易平台建立合作關係，開始為客戶提供更多元化的投資選擇。"
 },
 li03:{
 title:"2018年",
 desc:"成立投資研究部門，引進一群研究分析專家，開始發布市場研究報告和投資策略分析，提升公司專業影響力。"
 },
 li04:{
 title:"2020年",
 desc:"開發並推出自主研發的投資組合管理平台，為客戶提供更直觀、更便捷的資產管理體驗，同時在全球設立分公司。"
 },
 li05:{
 title:"2024年",
 desc:"實施數位轉型策略，升級客戶服務平台，引進人工智慧和大數據技術，提升投資分析與客戶服務能力。"
 },

 },
 model3:{
 title:"全球辦公室",
 contactInfo:"或請透過電子郵件聯絡我們，提供貴公司的基本資訊以及您想進一步了解的服務。我們將盡快與您聯繫。support {'@'}ftrademarkets.com",
 li01:{
 title:"香港",
 desc:`香港 九龍 海港城港威大廈 第6座25樓2509-12室<br>
 客服電話<br>
400-1208-921<br>
平日：9:00-18:00`
 },
 li02:{
 title:"墨爾本",
 desc:`121 Exhibition Street, Melbourne, Victoria 3000 Australia<br>
 客服電話<br>
+61 3 9651 8100<br>
平日：9:00-17:00`
 },
 li03:{
 title:"倫敦",
 desc:`倫敦聖殿區戈德史密斯大樓2樓東<br>
 客服電話<br>
+44 020 3036 0264<br>
平日：9:00-17:00`
 }

 },
 guide:{
 title:"與我們一起開啟財富增值之旅",
 desc:"我們期待與您建立長期的合作關係，為您提供專業的金融投資顧問服務。"
 }
 },
        //Products
 productsModel:{
 title:"我們的產品",
 desc:"我們全力以赴，助您做出更明智的交易決策。請繼續閱讀，了解我們為何與眾不同，並加入由超過 720,000 名差價合約交易者組成的活躍社區。",
 model1:{
 label:"CFD交易智能策略",
 title:"差價合約智能策略服務",
 desc:"依托先進的量化建模與大數據分析，提供CFD市場用戶專屬的智慧訊號、自動化策略與趨勢分析工具，適用於多樣化的金融資產類別。我們的方案致力於幫助投資人洞悉行情變化，把握市場機會，提升決策效率。",
 li01:{
 title:"智慧訊號推送",
 desc:"- 基於多因子量化模型，全天候輸出買賣提示與行情變化警報.護航。"
 },
 li02:{
 title:"策略訂閱支援",
 desc:"- 多款風格策略可依需求訂閱，適配不同市場需求與風險偏好"
 },
 li03:{
 title:"多市場數據分析",
 desc:"- 一體化追蹤外匯、指數、貴金屬等市場行情，提供多角度洞察"
 },
 li04:{
 title:"風險預警工具",
 desc:"- 內建多重風控模型，即時診斷市場風險，輔助調整投資策略"
 },
 },
 model2:{
 label:"投資組合",
 title:"智能投資組合管理",
 desc:"我們的投資組合管理服務採用現代投資理論和先進的數據分析技術，為您創建最優化的多元化資產配置方案。透過智慧演算法和專業顧問的結合，我們持續監控和調整您的投資組合，以實現長期穩健的回報。",
 li01:{
 title:"資產多元化",
 desc:"- 跨資產類別配置，降低單一市場風險"
 },
 li02:{
 title:"個人化訂製",
 desc:"- 根據您的風險承受能力和投資目標量身定制"
 },
 li03:{
 title:"持續再平衡",
 desc:"- 定期調整資產配置，維持最佳投資狀態"
 },
 li04:{
 title:"績效追蹤",
 desc:"- 即時監控投資表現與詳細報告分析"
 }
 },
 model3:{
 label:"風險管理",
 title:"全面風險管理工具",
 desc:"我們提供先進的風險管理工具和解決方案，幫助投資者識別、評估和減輕投資風險。透過量化模型和專業分析，我們幫助您在追求回報的同時有效控制風險敞口。",
 li01:{
 title:"風險評估",
 desc:"- 多維度評估投資組合風險，識別潛在問題"
 },
 li02:{
 title:"壓力測試",
 desc:"- 模擬極端市場狀況，評估投資組合的韌性"
 },
 li03:{
 title:"風險預警",
 desc:"- 即時監控，及時發現並通知異常風險"
 },
 li04:{
 title:"對沖策略",
 desc:"- 提供多種市場對沖工具，平滑投資波動"
 }
 },
 guide:{
 title:"準備好開始您的投資之旅？",
 desc:"聯絡我們的專業顧問，以獲得個人化的投資建議和產品推薦。"
 }
 },
        //Service
 serviceModel:{
 title:"策略分析顧問",
 desc:"我們提供全方位的專業金融服務，幫助您規劃財務未來，實現財富增值，保障資產安全。",
 model1:{
 label:"我們的服務類型",
 title:"全方位的金融顧問服務",
 desc:"無論您是個人投資者還是機構客戶，我們都能提供專業的解決方案滿足您的需求。(CFD)是一種允許您交易各類市場價格變動的金融衍生品，無需擁有標的資產。透過CFD交易，您可以在不持有實際資產的情況下，對股票、指數、外匯、商品等多種市場進行投機或對沖。",
 li01:{
 title:"投資策略諮詢",
 desc:"根據市場趨勢和您的投資目標，提供專業的投資策略建議，幫助您做出明智的投資決策。服務包括市場分析、資產配置推薦和個股/基金篩選等。",
 item01:"市場趨勢分析",
 item02:"投資機會識別",
 item03:"投資組合建議"
 },
 li02:{
 title:"財富管理",
 desc:"全面的財富管理服務，幫助您保護和增長您的資產。我們的專業團隊會根據您的財務狀況和目標，制定長期的財富規劃和管理方案。/基金篩選等。",
 item01:"資產配置優化",
 item02:"收益與風險平衡",
 item03:"定期績效評估"
 },
 li03:{
 title:"企業金融服務",
 desc:"為企業客戶提供全方位的金融諮詢服務，包括融資方案、財務規劃、投資管理和風險控制等，幫助企業優化財務結構，實現永續發展。/基金篩選等。",
 item01:"企業融資諮詢",
 item02:"資本結構優化",
 item03:"併購重組建議"
 },
 li04:{
 title:"風險管理諮詢",
 desc:"幫助您識別和管理投資中的各種風險，保障您的資產安全。我們提供風險評估、防範策略和危機應對方案，讓您的投資更加安全可靠。/基金篩選等。",
 item01:"風險評估與分析",
 item02:"對沖策略制定",
 item03:"損失控制機制"
 },
 li05:{
 title:"投資教育訓練",
 desc:"提供專業的投資知識培訓和教育課程，幫助投資者提升投資技能和知識水平。包括線上線下課程、研討會和一對一指導等多種形式。/基金篩選等。",
 item01:"投資基礎",
 item02:"市場分析技巧",
 item03:"交易策略訓練"
 },
 li06:{
 title:"退休規劃",
 desc:"提供全面的退休規劃服務，幫助您為退休生活做好財務準備。我們會考慮您的退休目標、時間範圍和預算，制定適合您的退休投資計劃。/基金篩選等。",
 item01:"退休需求分析",
 item02:"長期投資規劃",
 item03:"收入來源優化"
 },
 },

 guide:{
 title:"開啟您的財富加值之旅",
 desc:"立即預約免費諮詢，讓我們的專業團隊為您制定個人化的投資方案。"
 }
 },
 //Futureinvest app
 futureInvest:{
 year:"年",
 theme:{
 title:"全球市場，指尖交易<br>漲跌皆機遇，財富觸手可及!",
 subTitle:"1200萬交易者的信賴首選",
 openAccount:"開立帳戶",
 joinNow:"立即加入"
 },
 model1:{
 desc01:"行業深耕",
 desc02:"支持國家",
 desc03:"交易員",
 desc04:"交易品種"
 },
 model2:{
 title:"關於富騰匯",
 desc:"創立於2015年，全球真實交易量排名前十的CFD差價合約交易平台，為超過2600萬用戶提供安全、可靠、真實、透明的交易服務。"
 },
 model3:{
 title:"可信賴又安全的交易平台",
 li01:{
 title:"快速開戶",
 desc:"1分鐘開立真實與模擬帳號"
 },
 li02:{
 title:"好友交易享返傭",
 desc:"邀請越多返傭越多"
 },
 li03:{
 title:"",
 desc:"點差低至0.1"
 },
 li04:{
 title:"CFD交易 24/7",
 desc:"全年無休，隨時捕捉全球行情"
 }
 },
            productsModel:{

 label:"我們的產品",
 title:"差價合約交易",
 desc:"差價合約(CFD)是一種允許您交易各類市場價格變動的金融衍生品，無需擁有標的資產。透過CFD交易，您可以在不持有實際資產的情況下，對股票、指數、外匯、商品等多種市場進行投機或對沖。",
 li01:{
 title:"靈活槓桿",
 desc:"- 利用槓桿效應放大您的交易資金，獲取更大收益潛力.護航。"
 },
 li02:{
 title:"雙向交易",
 desc:"- 可以做多也可以做空，在任何市場方向都有獲利機會"
 },
 li03:{
 title:"多元市場",
 desc:"- 一個平台可交易全球範圍內的多種金融市場"
 },
 li04:{
 title:"風控管理",
 desc:"- 提供停損和止盈訂單，幫助控制和管理風險"
 },

 },
 model4:{
 title:"榮譽獎項",
 hostory:"多年歷史",
 license:"監理授權",
 award:"獎項",
 li01:{
 title:"最受投資者信賴CFD經紀商獎",
 desc:"國際 2024"
 },
 li02:{
 title:"全球最佳客戶資金安全獎",
 desc:"國際 2024"
 },
 li03:{
 title:"卓越數位化交易體驗獎",
 desc:"亞太區 2025"
 }
 },
 guide:{
 title:"立即開啟您的CFD交易之旅",
 desc:"立即預約免費諮詢，讓我們的專業團隊為您制定個人化的投資方案。"
 }
 },
 footer:{
 risk1:`風險警告<br>
差價合約 (CFD) 是一種複雜的金融工具，利用槓桿交易雖然可能放大收益，但同樣也會加劇虧損風險，導致資金快速流失。數據顯示，85.24% 的散戶投資者在使用該提供者服務進行差價合約交易時出現帳戶虧損。在進行交易之前，請確保您充分了解差價合約的運作機制，並仔細評估自己是否有能力承擔資金虧損的高風險。
<br><br>
免責聲明：<br>
Futren Ltd，根據聖露西亞（Saint Lucia）法律正式組成的國際商業公司（IBC），註冊地址位於Sotheby Building, Rodney Village, Rodney Bay, Gros Islet, Saint Lucia。<br>
Futren 被授權向全球專業投資者進行以下活動：提供金融產品建議、交易金融產品/申請收購或代表他人處置金融產品。一般建議警告：此建議可能不適合您，因為它包含未考慮您個人情況的一般建議。本網站提供的所有策略和資訊僅供參考。在根據此資訊採取行動之前，請預約尋求個人財務和稅務建議。
`,
risk2:`感謝您選擇我們的金融服務。投資有風險，入市需謹慎。金融市場存在波動性，可能導致本金損失，過往業績不代表未來表現。我們提供的分析、建議或產品資訊僅供參考，不構成任何投資建議或承諾。請您根據自身風險承受能力、財務狀況及投資目標謹慎決策。

本公司不對因市場變動、政策調整或其他不可抗力因素導致的投資損失負責。您需自行承擔投資決策的全部風險。建議您在投資前充分了解相關產品，必要時諮詢專業顧問。

本聲明為雙方權利義務的重要約定，請仔細閱讀。繼續使用本服務即視為您已瞭解並同意上述風險提示及免責條款。 `,
copyright:"Futren Limited 保留所有權利。",
 contact:`您也可以聯絡：<br><br>
 客服電話<br>
 400-1208-921<br>
 平日：9:00-18:00<br><br>

 電子郵件<br>
 support {'@'}ftrademarkets.com`,
 privacy:"隱私權條款",
 clientAgreement:"客戶協議"
 },
 platform:{
 title:"一款基於雲端訊息的應用程式",
 subTitle:"注重安全與速度",
 downBtn:"下載隨心所欲",
 downloading:"正在跳下載中...",
 downloadHint:"請稍候",
 }
    
}